// extracted by mini-css-extract-plugin
export default {"stat":"NumberStat_stat__ofym1"};